/**
 * Hariom ERP - Finance store (persisted, starts empty).
 * Finance team creates invoices; KPIs and the revenue/expenses chart are
 * derived from these records.
 */
import { createCrudStore } from './createCrudStore'

export interface Invoice {
  id: string
  invoiceNo: string
  type: string     // sales | purchase
  party: string
  amount: number
  gst: number
  total: number
  status: string   // paid | overdue | pending | partial
  date: string     // issue date (drives the monthly chart)
  due: string
  paid: number
}

export const useInvoiceStore = createCrudStore<Invoice>('hariom-erp-invoices')
